import { render, staticRenderFns } from "./UsageDistribution.vue?vue&type=template&id=03a55229&"
import script from "./UsageDistribution.vue?vue&type=script&lang=js&"
export * from "./UsageDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports